module.exports = __webpack_public_path__ + "img/chevron-right.3b351658.svg";